import { render } from "./property-card-schema.vue?vue&type=template&id=489eee56"
import script from "./property-card-schema.vue?vue&type=script&lang=js"
export * from "./property-card-schema.vue?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__